import React from 'react';
import { isProduction } from '@src/utils/env';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'impact-popup': {
        widget?: string;
        children?: React.ReactNode;
      };
    }
  }
}

const ReferralTag = () => {
  const urlNumber = isProduction() ? 35526 : 36063;

  return <impact-popup widget={`p/${urlNumber}/w/referrerWidget`}>Refer a Friend</impact-popup>;
};

export default ReferralTag;
